<template>
  <span class="editor-button__wrapper" @click="emit('click')">
    <SvgIcon :name="icon" class="editor-button" />
  </span>
</template>

<script setup>
defineProps({
  icon: {
    type: String,
    default: 'editor-button',
    validate: (value) => ['editor-button', 'delete', 'setting'].includes(value),
  },
});
const emit = defineEmits(['click']);
</script>
